import { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    Modal,
    Button,
    Card,
    CardHeader,
    CardBody,
    ButtonToolbar,
    Row,
    Col,
} from 'reactstrap';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import axios from "axios";
import { useDispatch, flashError } from "@/shared/components/flash"
import { prepareUrlByDomain } from '@/shared/helpers';
import Select from 'react-select'
import { Field, Form } from 'react-final-form';


const LoginAsModal = ({ program, isOpen, toggle, theme, rtl, user, auth }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [domainOptions, setDomainOptions] = useState(null);
    const [defaultDomain, setDefaultDomain] = useState(null);
    const [role, setRole] = useState({});

    useEffect(() => {
        if (!defaultDomain && program.default_domain && program.default_domain.length > 0) {
            setDefaultDomain({ 'label': program.default_domain[0].name, 'value': program.default_domain[0].id, ...program.default_domain[0] });
        }
        if (!domainOptions) {
            let options = [];
            program.domains.map((domain, i) => {
                options.push({ 'label': domain.name, 'value': '' + domain.id, ...domain })
            });
            setDomainOptions(options)
        }
    }, [program]);

    const onSubmit = (values) => {
        let payload = {
            "role_id": role.id
        }
        setLoading(true)
        const url = `/organization/${program.organization_id}/program/${program.id}/user/${user.id}/loginAs`
        axios.post(url, payload)
            .then((res) => {
                if (res.status === 200) {
                 
                    const domain = prepareUrlByDomain(values.domain);
                    const newWindow = window.open(domain, '_blank');

                    const handleReady = (event) => {
                        if (event.source !== newWindow) return;
                        if (event.data?.type === 'ready') {
                            window.removeEventListener('message', handleReady);

                            const data = {
                                role,
                                auth,
                                access_token: res.data.access_token,
                                organization_id: program.organization_id,
                                program_id: program.id,
                                user_id: user.id
                            };

                            newWindow.postMessage(data, domain);
                        }
                    };

                    window.addEventListener('message', handleReady);

                }
            })
            .catch(error => {
                // console.log(error.response.data);
                flashError(dispatch, error.response.data)
            })
            .finally(() => setLoading(false))
    }

    return (
        <Modal className={`modal-action modal-md ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}
            style={{ maxWidth: '500px' }}
        >
            <Card className='w-100'>
                <CardHeader tag="h3">
                    Login As
                    <Button className='btn float-end' close onClick={toggle} />
                </CardHeader>
                <CardBody>
                    <Form
                        onSubmit={onSubmit}
                        validate={validate}
                        initialValues={{ domain: defaultDomain }}
                    >
                        {({ handleSubmit }) => (
                            <form className="form" onSubmit={handleSubmit}>
                                <Field name="domain">
                                    {({ input, meta }) => (
                                        <Row className='mx-auto text-left'>
                                            <Col>
                                                <div>Select Domain:</div>
                                                <Select
                                                    {...input}
                                                    options={domainOptions}
                                                    placeholder='Select domain...'
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                />
                                                {meta.touched && meta.error && (
                                                    <span className="form__form-group-error">
                                                        {meta.error}
                                                    </span>
                                                )}
                                            </Col>
                                        </Row>
                                    )}
                                </Field>
                                <ButtonToolbar className="mt-5 d-flex w-100 justify-content-around flex-wrap">
                                    {user?.roles
                                        .filter(role => ['Manager', 'Limited Manager', 'Read Only Manager', 'Participant'].includes(role.name))
                                        .map(role => (
                                            <div key={role.id} className="me-2 mb-2">
                                                <Button
                                                    disabled={loading}
                                                    className="btn-sm"
                                                    type="submit"
                                                    color="primary"
                                                    onClick={() => setRole(role)}
                                                >
                                                    Log In as a {role.name}
                                                </Button>
                                            </div>
                                        ))}
                                </ButtonToolbar>
                            </form>
                        )}
                    </Form>
                </CardBody>
            </Card>
        </Modal>
    )
}

const validate = values => {
    let errors = {};
    if (!values.domain) {
        errors.domain = "Domain is required";
    }
    return errors;
}

LoginAsModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};

export default withRouter(connect((state) => ({
    auth: state.auth,
    theme: state.theme,
    rtl: state.rtl,
}))(LoginAsModal));
